import CryptoJS from "crypto-js";

export function arraysEqual(arr1, arr2) {
  if (arr1 === arr2) return true;
  if (arr1 == null || arr2 == null) return false;
  if (arr1.length !== arr2.length) return false;

  // Sort both arrays
  const sortedArr1 = arr1.slice().sort();
  const sortedArr2 = arr2.slice().sort();

  // Compare sorted arrays
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) return false;
  }
  return true;
}

export function arraysEqualElements(arr1, arr2) {
  arr2.forEach((x) => {
    if (!arr1.includes(x)) return false;
  });
  return true;
}

export function isUUID(str) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}

// Function to encrypt a string using AES encryption
export function encrypt(param) {

  const keyString = localStorage.getItem("key");
  const ivString = localStorage.getItem("iv");

  if (!keyString || !ivString) {
    console.error("Key or IV is missing. Encryption skipped.");
    return null;
  }

  const key = CryptoJS.enc.Latin1.parse(keyString); // 16-byte key
  const iv = CryptoJS.enc.Latin1.parse(ivString);  // 16-byte IV

  // Encrypt the parameter
  const encrypted = CryptoJS.AES.encrypt(param, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });

  // console.log('Encrypted:', encrypted.toString()); // Encrypted as Base64 string

  return encrypted.toString(); // Return as a Base64-encoded string
}

// Function to decrypt an encrypted string
export function decrypt(encrypted) {

  const keyString = localStorage.getItem("key");
  const ivString = localStorage.getItem("iv");

  if (!keyString || !ivString) {
    console.error("Key or IV is missing. Encryption skipped.");
    return null;
  }

  const key = CryptoJS.enc.Latin1.parse(keyString); // 16-byte key
  const iv = CryptoJS.enc.Latin1.parse(ivString);  // 16-byte IV

  // Decrypt the parameter
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });

  // console.log('Decrypted:', decrypted.toString(CryptoJS.enc.Utf8)); // Decrypted text
  return decrypted.toString(CryptoJS.enc.Utf8); // Return as a UTF-8 string
}

export const hashConverter = async (obj) => {
  const str = JSON.stringify(obj);
  // const data = new TextEncoder().encode(str);
  const hashed = CryptoJS.HmacSHA256(str, "1234");
  return hashed.toString(CryptoJS.enc.Hex);
  // const hashArray = Array.from(new Uint8Array(hashBuffer));
  // return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");

};

// FOR RESULTS AMS TABS VALUE COMPARISION FUNCTIONS

export const sanitizeScoreValue = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  const cleanedValue = String(value).replace(/\.$/, "").trim();
  if (!cleanedValue) {
    return "";
  }

  const numericValue = Number(cleanedValue);
  return Number.isNaN(numericValue) ? cleanedValue : numericValue;
};

export const normalizeScoreForComparison = (value, isCasual) => {
  if (value === null || value === undefined) {
    return isCasual ? "" : "0";
  }

  const cleanedValue = String(value).replace(/\.$/, "").trim();
  if (!cleanedValue) {
    return isCasual ? "" : "0";
  }

  const numericValue = Number(cleanedValue);
  if (Number.isNaN(numericValue)) {
    return cleanedValue;
  }

  if (numericValue === 0) {
    return isCasual ? "" : "0";
  }

  return numericValue.toString();
};

export const scoresAreEquivalent = (currentValue, originalValue, isCasual) => {
  return (
    normalizeScoreForComparison(currentValue, isCasual) ===
    normalizeScoreForComparison(originalValue, isCasual)
  );
};

export const formatScoreDisplay = (value, isCasual) => {
  const isEmpty = value === null || value === undefined || String(value).trim() === "";
  const numericValue = Number(value);

  if (isCasual) {
    return (!isEmpty && !Number.isNaN(numericValue) && numericValue !== 0)
      ? String(value)
      : "";
  }
  return isEmpty || Number.isNaN(numericValue) ? "0" : String(value);
};

export const sailNumComparator = (v1, v2, isAsc = true) => {
  // handle empty values - empty first in ASC, last in DESC
  if (!v1 && !v2) return 0;
  if (!v1) return -1;
  if (!v2) return 1;

  const s1 = String(v1);
  const s2 = String(v2);

  // 1: sort by character length
  if (s1.length !== s2.length) {
    const lengthDiff = s1.length - s2.length;
    return isAsc ? lengthDiff : -lengthDiff;
  }

  // 2: alphanumeric compare (natural order)
  const compareResult = s1.localeCompare(s2, undefined, {
    numeric: true,
    sensitivity: "base",
  });

  return isAsc ? compareResult : -compareResult;
};

// Helper: derive value from label (lowercase, underscores)
export const deriveValueFromLabel = (label) =>
  label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
